export default __webpack_public_path__ + "static/media/cosmos.3fef782559b7b3b27ab8817be79c6dd9.png";